<template>
  <div class="page-wrapper auth">
    <div class="page-inner">
      <div class="page-content-wrapper bg-transparent m-0">
        
        <div class="height-10 w-100 shadow-lg px-4" style="background-color: #015196;">
          <div class="d-flex align-items-center container p-0 h-100">
            
            <div class="d-flex align-items-center">
              <div>
                <span style="font-family: 'SF Fourche Regular', sans-serif; font-size: 20px; color: white; line-height: 1.2;">
                  {{ $t('common.drc') }}
                </span>
                <br>
                <div class="d-flex align-items-center">
                  <img src="/estamp-portal/assets/img/DrcFlagLogo.jpg" alt="DRC Flag Logo" style="max-width: 50px; margin-right: 10px;">
                  <span style="font-family: 'SF Fourche Regular', sans-serif; font-size: 16px; color: white;">
                    {{ $t('common.ministry') }}
                  </span>
                </div>
              </div>
            </div>

            <div class="d-flex align-items-center ml-auto">
              <!-- Language Switcher Component -->
              <language-switcher />
              
              <a href="/estamp-portal/#/login" class="btn-link text-white fw-500 ml-4">
                {{ $t('common.verifyUIM') }}
              </a>
              <a href="/estamp-portal/#/login" class="btn-link text-white fw-500 ml-3">
                {{ $t('auth.login') }}
              </a>
            </div>
          </div>
        </div>
        <br><br><br>
        <div class="flex-1"
          style="background: url(/estamp-portal/assets/img/svg/pattern-1.svg) no-repeat center bottom fixed; background-size: cover;">
          <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
            <div class="row">
              <div class="col col-md-6 col-lg-7 hidden-sm-down">
                <h2 class="">
                  {{ $t('home.trackTraceSystem') }}
                  <p class="h2 fw-300 mt-3 mb-5 opacity-60">
                    {{ $t('home.aboutDescription') }}
                  </p>
                </h2>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4 ml-auto">
                <h1 class="text-primary fw-300 mb-3 d-sm-block d-md-none">
                  {{ $t('auth.secureLogin') }}
                </h1>
                <div class="card p-4 rounded-plus bg-faded">
                  <form class="login-form" @submit.prevent="onSubmit">
                    <dx-form :form-data="formData" :disabled="loading" label-location="top">
                      <dx-item data-field="Login_Name" editor-type="dxTextBox"
                        :editor-options="{ mask: '+243 000 000 000', placeholder: $t('auth.phonePlaceholder') }">
                        <dx-required-rule :message="$t('auth.phoneRequired')" />
                        <dx-label :text="$t('auth.phone')" />
                      </dx-item>
                      <br><br><br>
                      <dx-item data-field='Password' editor-type='dxTextBox'
                        :editor-options="{ mode: 'password' }">
                        <dx-required-rule :message="$t('auth.passwordRequired')" />
                        <dx-label :text="$t('auth.password')" />
                      </dx-item>
                      <dx-button-item>
                        <dx-button-options width="100%" type="normal" template="signInTemplate"
                          :use-submit-behavior="true">
                        </dx-button-options>
                      </dx-button-item>
                      <dx-item>
                        <template #default>
                          <div class="link">
                            <a href="#" @click.prevent="showForgotPasswordPopup">{{ $t('auth.forgotPassword') }}</a>
                          </div>
                        </template>
                      </dx-item>
                      <dx-button-item>
                        <dx-button-options :text="$t('auth.stakeholderRegistration')" width="100%"
                          :on-click="onCreateAccountClick" />
                      </dx-button-item>
                      <template #signInTemplate>
                        <span>{{ $t('auth.login') }}</span>
                      </template>
                    </dx-form>
                  </form>
                </div>
              </div>
            </div>
            <div class="position-absolute pos-bottom pos-left pos-right p-3 text-center">
            <a href='#' class='opacity-40 fw-500' title='#' target='_blank' style="color:black;">2025 © {{ $t('common.drc') }}
              {{ $t('common.ministry') }}</a>
          </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Forgot Password Popup -->
    <DxPopup
      :visible="forgotPasswordVisible"
      :width="400"
      :height="300"
      :show-title="true"
      :show-close-button="true"
      :title="$t('auth._forgotPassword')"
      :close-on-outside-click="false"
      @hiding="onForgotPasswordPopupHiding">
      <div>
        <form action="action" @submit.prevent="onForgotPasswordSubmit">
        <DxForm :form-data="forgotPasswordData" label-location="top">
          <DxItem 
            data-field="phoneNumber" 
            editor-type="dxTextBox"
            :editor-options="{
              mask: '+243 000 000 000', 
              placeholder: $t('auth.phonePlaceholder') 
            }">
            <DxRequiredRule :message="$t('auth.phoneRequired')" />
            <DxLabel :text="$t('auth.phone')" />
          </DxItem>
          
          <DxButtonItem>
            <DxButtonOptions 
              :text="$t('auth.submit')" 
              width="100%" 
              type="normal"
              :use-submit-behavior="true"
              :disabled="forgotPasswordLoading"
            />
          </DxButtonItem>
        </DxForm>
        </form>
      </div>
    </DxPopup>

    <!-- Forgot Password Popup -->
    <DxPopup
      :visible="resetPasswordVisible"
      :width="800"
      :height="400"
      :show-title="true"
      :show-close-button="true"
      :title="$t('auth.resetPassword')"
      :close-on-outside-click="false"
      @hiding="onResetPasswordPopupHiding">
      <div>
        <form action="action" @submit.prevent="onResetPasswordSubmit">
        <DxForm :form-data="resetPasswordData" label-location="top" :col-count="2">
          <DxItem 
           :col-span="1"
            data-field="phoneNumber" 
            editor-type="dxTextBox"
            :editor-options="{
              mask: '+243 000 000 000', 
              placeholder: $t('auth.phonePlaceholder') 
            }">
            <DxRequiredRule :message="$t('auth.phoneRequired')" />
            <DxLabel :text="$t('auth.phone')" />
          </DxItem>

          <DxItem 
            :col-span="1"
            data-field="otpCode" 
            editor-type="dxTextBox"
            :editor-options="{
              mask: '000 000',
              placeholder: $t('auth.otpCode') 
            }">
            <DxRequiredRule :message="$t('auth.otpCodeRequired')" />
            <DxLabel :text="$t('auth.otpCode')" />
          </DxItem>

          <DxItem 
            :ol-span="1"
            data-field="password" 
            editor-type="dxTextBox"
            :editor-options="{
              mode: 'password',
              placeholder: $t('auth.password') 
            }">
            <DxRequiredRule :message="$t('auth.passwordRequired')" />
            <DxLabel :text="$t('auth.password')" />
          </DxItem>

          <DxItem 
            :col-span="1"
            data-field="confirmPassword" 
            editor-type="dxTextBox"
            :editor-options="{
              mode: 'password',
              placeholder: $t('auth.confirmPassword') 
            }">
            <DxRequiredRule :message="$t('auth.confirmPasswordRequired')" />
            <DxCompareRule :comparison-target="passwordComparison" :message="$t('registration.passwordMismatch')" />
            <DxLabel :text="$t('auth.confirmPassword')" />
          </DxItem>
          
          <DxButtonItem :col-span="2">
            <DxButtonOptions
              :text="$t('auth.submit')" 
              width="100%" 
              type="normal"
              :use-submit-behavior="true"
              :disabled="resetPasswordLoading"
            />
          </DxButtonItem>
        </DxForm>
        </form>
      </div>
    </DxPopup>    
  </div>
</template>

<script>
import { DxForm, DxItem, DxRequiredRule, DxLabel, DxButtonItem, DxButtonOptions } from 'devextreme-vue/form'
import { DxPopup } from 'devextreme-vue/popup';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

export default {
  name: 'Login',
  components: {
    DxForm,
    DxItem,
    DxRequiredRule,
    DxLabel,
    DxButtonItem,
    DxButtonOptions,
    LanguageSwitcher,
    DxPopup
  },
  data() {
    return {
      formData: {
        Login_Name: '',
        Password: ''
      },
      loading: false,
      forgotPasswordVisible: false,
      forgotPasswordLoading: false,
      forgotPasswordData: {
        phoneNumber: ''
      },
      resetPasswordVisible: false,
      resetPasswordLoading: false,
      resetPasswordData: {
        phoneNumber: '',
        otpCode: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    passwordComparison() {
      return this.resetPasswordData.password
    },
  },
  methods: {
    async onSubmit() {
      this.loading = true
      try {
        await this.$store.dispatch('user/LOGIN', this.formData)
        this.$toast.success(this.$t('auth.loginSuccess'))
        this.$router.push('/home')
      } catch (error) {
        this.$toast.error(this.$t('auth.loginError'))
      } finally {
        this.loading = false
      }
    },
    onCreateAccountClick() {
      this.$router.push('/register')
    },
    
    showForgotPasswordPopup() {
      this.forgotPasswordVisible = true
      this.forgotPasswordData.phoneNumber = ''
    },
    
    onForgotPasswordPopupHiding() {
      this.forgotPasswordVisible = false
      this.forgotPasswordData.phoneNumber = ''
    },

    async onForgotPasswordSubmit() {
      this.forgotPasswordLoading = true
      try {
        await this.$store.dispatch('application/FORGOT_PASSWORD', this.forgotPasswordData)
        this.$toast.success(this.$t('auth.forgotPasswordSuccess'))
        this.forgotPasswordVisible = false
        this.forgotPasswordData.phoneNumber = ''
        this.showResetPasswordPopup()
      } catch (error) {
        this.$toast.error(this.$t('auth.forgotPasswordError'))
      } finally {
        this.forgotPasswordLoading = false
      }
    },

  // Start Reset Password
    showResetPasswordPopup() {
      this.resetPasswordVisible = true
      this.resetPasswordData.phoneNumber = ''
      this.resetPasswordData.otpCode = ''
      this.resetPasswordData.password = ''
      this.resetPasswordData.confirmPassword = ''
    },
    
    onResetPasswordPopupHiding() {
      this.resetPasswordVisible = false
      this.resetPasswordData.phoneNumber = ''
      this.resetPasswordData.otpCode = ''
      this.resetPasswordData.password = ''
      this.resetPasswordData.confirmPassword = ''
    },

    async onResetPasswordSubmit() {
      this.resetPasswordLoading = true
      try {
        await this.$store.dispatch('application/RESET_PASSWORD', this.resetPasswordData)
        this.$toast.success(this.$t('auth.resetPasswordSuccess'))
        this.resetPasswordVisible = false
        this.resetPasswordData.phoneNumber = ''
        this.resetPasswordData.otpCode = '' 
        this.resetPasswordData.password = ''
        this.resetPasswordData.confirmPassword = ''
      } catch (error) {
        this.$toast.error(this.$t('auth.resetPasswordError'))
      } finally {
        this.resetPasswordLoading = false
      }
    },
  }
}
</script>

<!-- <style scoped>
.forgot-password-content {
  padding: 20px;
}

.forgot-password-content p {
  text-align: center;
  margin-bottom: 20px;
}

.link a {
  color: #007bff;
  text-decoration: none;
}

.link a:hover {
  text-decoration: underline;
}
</style> -->